import { PlusIcon } from "@heroicons/react/24/outline";
import {
  BuildingOfficeIcon,
  GlobeAltIcon,
  IdentificationIcon,
  PhoneIcon,
  UserCircleIcon,
} from "@heroicons/react/20/solid";
import FormInput from "../../../../components/controls/FormInput";
import Autocomplete from "../../../../components/Places/PlacesAutocomplete";
import ImageUploader from "../../../../components/controls/ImageUploader";

export default function CompanyEditor({
  companies,
  setCompanies,
  activeCompanyIndex,
  setActiveCompanyIndex,
  isReadOnly,
  t,
}) {
  const addCompany = () => {
    const newCompany = {
      name: "",
      neqNumber: "",
      address: "",
      phoneNumber: "",
      contactPerson: "",
      website: "",
      contactEmail: "",
      imageUrl: "",
      subscriptionTier: 1,
      userId: null,
      location: null,
      tempImageUrl: "",
      isActive: true,
    };
    setCompanies([...companies, newCompany]);
    setActiveCompanyIndex(companies.length);
  };

  const updateCompanyField = (field, value) => {
    const updated = [...companies];
    updated[activeCompanyIndex][field] = value;
    setCompanies(updated);
  };

  const currentCompany = companies[activeCompanyIndex];

  return (
    <div className="tab-content border-base-300 bg-base-100 p-4">
      <div className="mb-4">
        <button
          type="button"
          className="btn btn-sm rounded-full bg-primary text-white hover:bg-accent"
          onClick={addCompany}
        >
          <PlusIcon className="w-5 h-5" />
          {t("adminUserTable.addCompany")}
        </button>
      </div>

      {companies.length > 0 && (
        <div className="tabs tabs-lifted w-full mb-4">
          {companies.map((c, index) => (
            <a
              key={index}
              className={`tab ${
                activeCompanyIndex === index
                  ? "tab-active bg-gray-300 rounded-lg"
                  : ""
              }`}
              onClick={() => setActiveCompanyIndex(index)}
            >
              {c?.name?.trim() || t("adminUserTable.newCompany")}
            </a>
          ))}
        </div>
      )}

      {!currentCompany ? (
        <p className="text-center text-gray-500 italic">
          {t("adminUserTable.noCompany")}
        </p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 border p-4">
          <div className="col-span-1 sm:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-2">
            <FormInput
              label={t("becomeProvider.companyNameLabel")}
              disabled={isReadOnly}
              value={currentCompany.name}
              placeholder={t("becomeProvider.companyNamePlaceholder")}
              onChange={(name, value) => updateCompanyField("name", value)}
              required
              icon={<BuildingOfficeIcon className="w-5 h-5 text-gray-500" />}
            />
            <Autocomplete
              disabled={isReadOnly}
              onSelect={(e) => {
                updateCompanyField("address", e.formattedAddress);
                updateCompanyField("location", e);
              }}
              initialAddress={currentCompany.address || ""}
            />
            <FormInput
              label={t("becomeProvider.contactEmailLabel")}
              disabled={isReadOnly}
              value={currentCompany.contactEmail || ""}
              placeholder={t("becomeProvider.contactEmailPlaceholder")}
              onChange={(name, value) =>
                updateCompanyField("contactEmail", value)
              }
              required
            />
            <FormInput
              label={t("becomeProvider.phoneNumberLabel")}
              disabled={isReadOnly}
              value={currentCompany.phoneNumber}
              placeholder={t("becomeProvider.phoneNumberPlaceholder")}
              onChange={(name, value) =>
                updateCompanyField("phoneNumber", value)
              }
              icon={<PhoneIcon className="w-5 h-5 text-gray-500" />}
              required
            />
            <FormInput
              label={t("becomeProvider.contactPersonLabel")}
              disabled={isReadOnly}
              value={currentCompany.contactPerson}
              placeholder={t("becomeProvider.contactPersonPlaceholder")}
              onChange={(name, value) =>
                updateCompanyField("contactPerson", value)
              }
              icon={<UserCircleIcon className="w-5 h-5 text-gray-500" />}
              required
            />
            <FormInput
              label={t("becomeProvider.neqNumberLabel")}
              disabled={isReadOnly}
              value={currentCompany.neqNumber}
              placeholder={t("becomeProvider.neqNumberPlaceholder")}
              onChange={(name, value) => updateCompanyField("neqNumber", value)}
              icon={<IdentificationIcon className="w-5 h-5 text-gray-500" />}
            />
            <FormInput
              label={t("becomeProvider.websiteLabel")}
              disabled={isReadOnly}
              value={currentCompany.website}
              placeholder={t("becomeProvider.websitePlaceholder")}
              onChange={(name, value) => updateCompanyField("website", value)}
              icon={<GlobeAltIcon className="w-5 h-5 text-gray-500" />}
            />
          </div>

          <div>
            <ImageUploader
              disabled={isReadOnly}
              initialImageUrl={
                currentCompany.tempImageUrl || currentCompany.imageUrl || ""
              }
              onTempImageChange={(url) => {
                const updated = [...companies];
                updated[activeCompanyIndex].tempImageUrl = url?.trim()
                  ? url
                  : null;
                updated[activeCompanyIndex].hasChangedImageUrl = true;
                setCompanies(updated);
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}
